import {FC, ReactNode} from 'react';
import {styled} from 'styled-components';

import {Flex} from '@shared_web/components/core2/flex';

import {IconCircle} from '@mavismart_frontend/pages/tabs/door_info';

export interface GenericInfoBlockItem {
  key: string;
  title?: ReactNode;
  subtitle: ReactNode;
}

interface InfoBlockProps {
  icon: ReactNode;
  items: GenericInfoBlockItem[];
}

export const GenericInfoBlock: FC<InfoBlockProps> = props => {
  const {icon, items} = props;
  return (
    <Wrapper>
      <IconCircle>{icon}</IconCircle>
      <Flex $column>
        {items.map(item => (
          <div key={item.key}>
            {item.title && <Label>{item.title} </Label>}
            {item.subtitle}
          </div>
        ))}
      </Flex>
    </Wrapper>
  );
};

GenericInfoBlock.displayName = 'InfoBlock';

const Wrapper = styled.div`
  display: flex;
  background: #00000008;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px;
  min-width: 0;
  word-break: break-word;
  align-items: center;
  gap: 10px;
`;

const Label = styled.span`
  font-weight: 600;
  margin-bottom: 2px;
  max-width: 100%;
  word-break: break-word;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
`;
